// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"

import AutoCompleteController from "./autocomplete_controller"
import AdminBottleController from "./admin_bottle_controller"
import AdminWineController from "./admin_wine_controller"
import AddressController from "./address_controller"
import BottlePagingController from "./bottle_paging_controller"
import BurgerMenuController from "./burger_menu_controller"
import CommissionController from "./commission_controller"
import EthWalletController from "./eth_wallet_controller"
import FilterController from "./filter_controller"
import FilterMobileController from "./filter_mobile_controller"
import IndexController from "./index_controller"
import MapController from "./map_controller"
import MenuController from "./menu_controller"
import SlideshowController from "./slideshow_controller"
import TableHelperController from "./table_helper_controller"
import TabController from "./tab_controller"
import WineController from "./wine_controller"
import MintProcessController from "./mint_process_controller";

application.register("admin-bottle", AdminBottleController)

application.register("autocomplete", AutoCompleteController)

application.register("admin-wine", AdminWineController)

application.register("bottle-paging", BottlePagingController)

application.register("address", AddressController)

application.register("burger-menu", BurgerMenuController)

application.register("commission", CommissionController)

application.register("eth-wallet", EthWalletController)

application.register("filter", FilterController)

application.register("filter-mobile", FilterMobileController)

application.register("index", IndexController)

application.register("map", MapController)


application.register("menu", MenuController)

application.register("slideshow", SlideshowController)

application.register("table-helper", TableHelperController)

application.register("tab", TabController)

application.register("wine", WineController)

application.register("mint-process", MintProcessController)
